import React from 'react';
import {NavLink} from 'react-router-dom';

const navItems = [
  {to: '/admin', label: 'Dashboard'},
  {to: '/admin/users', label: 'Korisnici'},
  {to: '/admin/listings', label: 'Nekretnine'},
  {to: '/admin/orders', label: 'Orderi'},
  {to: '/admin/products', label: 'Token paketi'},
];

const AdminNav: React.FC = () => (
  <nav className="rounded-2xl border border-neutral-200 bg-white p-5 shadow-soft">
    <p className="text-xs uppercase tracking-[0.3em] text-neutral-400">Navigacija</p>
    <div className="mt-4 space-y-2">
      {navItems.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/admin'}
          className={({isActive}) =>
            `block rounded-xl px-4 py-3 text-base font-medium transition ${
              isActive
                ? 'bg-primary-50 text-primary-700 shadow-soft'
                : 'text-neutral-600 hover:bg-neutral-50'
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </div>
  </nav>
);

export default AdminNav;
